import React, { ReactNode } from "react";
import { Switch, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DashboardPage from "../dashboard/Dashboard";
import ProfilePage from "../profile/ProfilePage";
import SignInPage from "../signin/SignInPage";
import SignUpPage from "../signup/SignUpPage";
import TermsAndConditionsPage from "../content/TermsAndConditions";
import CodeOfConductPage from "../content/CodeOfConduct";
import StatementPage from "../statements/StatementPage";
import NotFoundPage from "./NotFoundPage";
import ForgotPasswordPage from "../forgotpassword/ForgotPasswordPage";
import FrequentlyAskedQuestionsPage from "../content/FrequentlyAskedQuestions";
import ContactPage from "../content/Contact";
import SettingsPage from "../content/Settings";
import Header from "./Header";
import { Grid, Hidden } from "@material-ui/core";
import Spinner from "../shared/Spinner";

const debugColor = "";

export function PageContainer({ children }: { children: ReactNode }) {
  const { ready } = useTranslation();

  if (!ready) return <Spinner isVisible={true} />;

  // For small screens and larger (sm) there is a left and right space, which disappears for very small screens (xs).
  return (
    <Grid container item xs={12}>
      <Hidden xsDown>
        <Grid item sm={1} style={{ backgroundColor: debugColor }} />
      </Hidden>
      <Grid container item xs={12} sm={10}>
        {children}
      </Grid>
      <Hidden xsDown>
        <Grid item sm={1} style={{ backgroundColor: debugColor }} />
      </Hidden>
    </Grid>
  );
}

export default function Page() {
  const { t } = useTranslation();

  return (
    <Switch>
      <Route path="/" exact>
        <Header />
        <PageContainer>
          <DashboardPage />
        </PageContainer>
      </Route>
      <Route path="/s/:slug">
        <Header />
        <PageContainer>
          <StatementPage />
        </PageContainer>
      </Route>
      <Route path="/signin">
        {/* <Header /> */}
        <PageContainer>
          <SignInPage />
        </PageContainer>
      </Route>
      <Route path="/signup">
        {/* <Header /> */}
        <PageContainer>
          <SignUpPage />
        </PageContainer>
      </Route>
      <Route path="/forgot-password">
        {/* <Header /> */}
        <PageContainer>
          <ForgotPasswordPage />
        </PageContainer>
      </Route>
      <Route path="/profile/:userId?">
        <Header title={t("profile.profile")} />
        <PageContainer>
          <ProfilePage />
        </PageContainer>
      </Route>
      <Route path="/terms-and-conditions">
        <Header title={t("termsandconditions.termsandconditions")} />
        <PageContainer>
          <TermsAndConditionsPage />
        </PageContainer>
      </Route>
      <Route path="/code-of-conduct">
        <Header title={t("codeofconduct.codeofconduct")} />
        <PageContainer>
          <CodeOfConductPage />
        </PageContainer>
      </Route>
      <Route path="/frequently-asked-questions">
        <Header
          title={t("frequentlyaskedquestions.frequentlyaskedquestions")}
        />
        <PageContainer>
          <FrequentlyAskedQuestionsPage />
        </PageContainer>
      </Route>
      <Route path="/contact">
        <Header title={t("contact.contact")} />
        <PageContainer>
          <ContactPage />
        </PageContainer>
      </Route>
      <Route path="/settings">
        <Header title={t("menu.settings")} />
        <PageContainer>
          <SettingsPage />
        </PageContainer>
      </Route>
      <Route>
        <Header title={t("notfound.notfound")} />
        <PageContainer>
          <NotFoundPage />
        </PageContainer>
      </Route>
    </Switch>
  );
}
